export const defaultContent = {
  hero: {
    badge: 'Clinical-Grade Telemetry',
    title: 'Engineering the Extraordinary in Geriatric Remote Monitoring.',
    subtitle:
      'Transition from reactive medical interventions to proactive, continuous surveillance with the Zenzers multi-sensor wearable.',
    cta: 'Build Your System',
    secondaryCta: 'Watch Demo',
    // Android app download shown under the hero CTAs. Data-driven so it's editable
    // per-tenant from the admin console Storefront → Marketing Content JSON (set
    // appDownloadUrl:'' to hide for a brand). Hidden on the luxury skin regardless.
    appDownloadUrl: 'https://www.zenzers4life.com/media/zenzers-downloads/zenzers-latest.apk',
    appDownloadLabel: 'Download Android App',
    // Optional hero product image (URL). When set on the luxury skin, the
    // rendered SVG ring is replaced with real product photography.
    image: '',
    watchStats: {
      accuracy: '99.7%',
      label: 'Fall Detection\nAccuracy',
      heartRate: '68 bpm',
      spo2: '98% SpO2',
    },
  },
  pillars: {
    title: 'The Four Pillars of Care',
    subtitle:
      'A comprehensive ecosystem designed to eradicate the stigma of legacy "panic button" devices.',
    items: [
      {
        icon: 'solar:smart-watch-linear',
        title: 'The Hardware Play',
        description: 'Unobtrusive, clinical-grade wrist telemetry. No restrictive chest straps required.',
      },
      {
        icon: 'solar:cpu-linear',
        title: 'The Intelligence Play',
        description: 'Edge AI (TinyML) processing via FreeRTOS ensures zero-latency alerts (<200ms).',
      },
      {
        icon: 'solar:graph-up-linear',
        title: 'The Clinical Play',
        description: 'Continuous vital sign synthesis including Respiratory Rate, Heart Rate, and SpO2.',
      },
      {
        icon: 'solar:chat-round-dots-linear',
        title: 'The Ecosystem Play',
        description: 'Adina conversational AI for automated charting and subjective health monitoring.',
      },
    ],
  },
  edge: {
    title: 'The Zenzers Edge Advantage',
    subtitle: 'Why local processing outperforms legacy systems.',
    traditional: {
      title: 'Traditional Cloud Dependency',
      icon: 'solar:cloud-cross-linear',
      items: [
        'High latency processing creates delays during critical falls.',
        'Constant cloud transmission causes rapid battery drain.',
        'Continuous data streaming increases privacy exposure.',
      ],
    },
    zenzers: {
      title: 'The Zenzers Edge',
      icon: 'solar:cpu-linear',
      badge: 'The Standard',
      items: [
        'Immediate alerts via on-device TinyML processing.',
        '10.4 mAh ultra-low power budget for extended wear.',
        'Local data privacy; only actionable insights are transmitted.',
      ],
    },
  },
  adina: {
    badge: 'Virtual Companion',
    assistantName: 'Adina AI',
    title: 'Meet Adina.',
    titleLine2: 'Your Automated Scribe.',
    description:
      'Adina engages in natural conversation to monitor subjective health metrics, automatically summarizing interactions into structured medical charts for the caregiver portal.',
    features: ['Contextual pain assessment', 'Zero-click clinical charting'],
    chat: [
      { sender: 'adina', text: 'Good morning, Robert. Your heart rate is stable today. How are you feeling?' },
      { sender: 'patient', text: 'My back hurts a little bit.' },
      { sender: 'adina', text: "I'm sorry to hear that. Is the pain sharp, dull, or throbbing?" },
    ],
    autoChart: {
      title: 'Auto-Chart Updated',
      description: 'Subjective back pain noted. Awaiting descriptor. Alert queued for caregiver portal.',
    },
  },
  nav: [
    { label: 'Features', href: '#features' },
    { label: 'The Edge', href: '#edge' },
    { label: 'Adina AI', href: '#adina' },
    { label: 'Pricing', href: '#pricing' },
  ],
  pricing: {
    title: 'Shop & Subscribe',
    subtitle: 'Build your system in two simple steps.',
  },
  footer: {
    links: [
      { label: 'HIPAA Compliance', href: '/privacy#hipaa' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Support', href: 'mailto:support@zenzers4life.com' },
      { label: 'Contact', href: 'mailto:hello@zenzers4life.com' },
    ],
    copyright: '\u00A9 2026 Zenzers Inc.',
  },
  auth: {
    signIn: {
      title: 'Secure Portal',
      subtitle: 'Sign in to access patient telemetry and charting.',
    },
    accountType: {
      title: 'Create Your Account',
      subtitle: 'Select your role to get started.',
      roles: {
        patient: { title: 'Patient', description: 'Monitor your health with continuous wearable telemetry.' },
        doctor: { title: 'Medical Professional', description: 'Access clinical dashboards and patient charting.' },
        caregiver: { title: 'Caregiver', description: 'Stay connected with real-time alerts and reports.' },
      },
    },
  },
}
